import React from "react";

import clsx from "clsx";

import { GenericTooltip } from "@components/tooltip-container";
import { type SalesPageMetricWithChildren } from "@features/sales-v3/utils/metric-categorizer";
import { CustomCheckbox } from "@shared/custom-checkbox";

type Props = {
  isSelected: boolean;
  metric: SalesPageMetricWithChildren;
  selectMetric: (metric: SalesPageMetricWithChildren) => void;
  deselectMetric: (metric: SalesPageMetricWithChildren) => void;
  isChild?: boolean;
  className?: string;
};

const getMetricDisplayName = (
  metric: SalesPageMetricWithChildren,
  isChild: boolean,
) => {
  if (!metric.metadata) {
    return metric.name;
  } else if (isChild) {
    return metric.metadata.type;
  } else if (metric.metadata?.name) {
    return metric.metadata.name;
  }

  return metric.name;
};

export const MetricSelection = ({
  isSelected,
  metric,
  selectMetric,
  deselectMetric,
  isChild = false,
  className,
}: Props) => {
  return (
    <div
      className={clsx("flex items-center py-2 cursor-pointer", className)}
      onClick={() => {
        if (isSelected) {
          deselectMetric(metric);
        } else {
          selectMetric(metric);
        }
      }}
    >
      <CustomCheckbox className="mr-2" checked={isSelected} />
      <GenericTooltip
        className="truncate"
        overlayClassName="pointer-events-none"
        noInfoCircle
        mouseEnterDelay={500}
        content={
          <div className="text-xs max-w-[360px]">
            <div className="text-gray+1 font-light mb-0.5">Metric Name</div>
            <p>{metric.name}</p>
            <div className="text-gray+1 font-light mb-0.5">What is it?</div>
            <p dangerouslySetInnerHTML={{ __html: metric.descriptionHTML }}></p>
          </div>
        }
      >
        {getMetricDisplayName(metric, isChild)}
      </GenericTooltip>
    </div>
  );
};
